/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';

export const PurchaseOrderStatus = createEnum('PURCHASE_ORDER_STATUS', {
  Pending: 1,
  Accepted: 2,
  Rejected: 3,
});
export type PurchaseOrderStatus = EnumSet<typeof PurchaseOrderStatus>;

export type PurchaseOrdersDto = WithVersion<{
  jobOrderId: ID;
  orderNumber: number;
  status: string;
  statusValue: PurchaseOrderStatus;
  deliveryDate: Date;
  fileUrl: string;
  officeName: string;
  purchaseOrder: string;
}>;
